import { AlpineData, LivewireData, LivewireMethods } from "@/js/interfaces/Components/alpinejs/AnnounceTextarea";
import { createAlpineLivewireComponent } from "@nolikein/typed-alpinejs";

/* Generated from the "artisan make:alpine" command */
export default {
    name: 'AnnounceTextarea',
    component: (
        // Component parameters...
        defaultContent = '',
    ) => createAlpineLivewireComponent<AlpineData, LivewireData, LivewireMethods>({
        // Component properties ...
        content: defaultContent,

        /**
         * Initialize the component
         */
        init() {
            // Catch content and call livewire
            this.$watch('content', (value: string) => {
                this.$nextTick(() => {
                    /** @ts-expect-error Cannot understand Javascript object path to string conversion */
                    this.$wire.$set('form.content', value);
                });
            });
        },


        insertAtCursor(textarea: HTMLTextAreaElement, text: string): void {
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const before = this.content.substring(0, start);
            const after = this.content.substring(end);
            this.content = before + text + after;

            // Replace selection and move cursor after inserted text
            textarea.selectionStart = textarea.selectionEnd = start + text.length;
            textarea.focus();
        },

        appendMarkdownContent(type: string): void {
            const editor = this.$refs.editor as HTMLTextAreaElement | undefined;
            if (undefined === editor) {
                throw new Error('Editor reference not found');
            }
            const textSelection = editor.value.substring(editor.selectionStart, editor.selectionEnd);

            let snippet: string | false;
            if (false === (snippet = this.getCompletedSnippet(type, textSelection))) {
                snippet = this.getBasicSnippet(type);
            }

            if (false !== snippet) {
                this.insertAtCursor(editor, snippet);
            }
        },

        getBasicSnippet(type: string): string | false {
            const markdownSnippets: Record<string, string> = {
                'table': "\n| Header 1 | Header 2 |\n| --- | --- |\n| Row 1 Col 1 | Row 1 Col 2 |\n| Row 2 Col 1 | Row 2 Col 2 |\n",
            };

            const snippet = markdownSnippets[type];
            if (!snippet) {
                return false;
            }

            return snippet;
        },

        getCompletedSnippet(type: string, text: string): string | false {
            const markdownSnippets: Record<string, { before: string, after: string }> = {
                'bold': { before: '**', after: '**' },
                'italic': { before: '*', after: '*' },
                'underline': { before: '~~', after: '~~' },
                'link': { before: '[Nom](', after: ')' },
                'image': { before: '![alternativeText](', after: ')' },
                'heading': { before: '# ', after: '' },
                'list': { before: '\n- ', after: '\n' },
            };

            const snippet = markdownSnippets[type];
            if (!snippet) {
                return false;
            }

            return `${snippet.before}${text.trim()}${snippet.after}`;
        },
    }),
};
